import styled from 'styled-components';
import {
  Input as SemanticInput,
} from 'semantic-ui-react';
import { Button as ButtonComponent, Text as TextLayoutComponent, Loader as LoaderComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: white;
  border: 1px solid #efefef;
  border-radius: 2px;
  margin-top: 10px;
  max-width: 100%;
`;

export const FeedbackMessage = styled(TextLayoutComponent)`
  align-self: flex-end;
  display: flex;
  align-self: center;
  white-space: nowrap;
`;

export const Input = styled(SemanticInput)`
  width: 100%;
  padding: 12px;
  &&& > * {
  border: unset;
  font-family: Roboto;
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  }
  &&& > *:focus{
    border: unset;
  }
`;

export const Loader = styled(LoaderComponent)`
  &&& {
    margin: auto;
  }
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  font-size: 16px;
  text-align: center;
  && {
    margin: auto;
  };
`;

export const ContainerFroala = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  max-width: 100%;
  &&& div > * {
   border: unset;
  }
  .fr-box.fr-basic{
    flex: 1;
    display: flex;
    max-width: 100%;
    flex-direction: column;
  }
  .fr-box.fr-basic.fr-top .fr-wrapper{
    overflow-y: auto;
    flex: 1;
    display: flex;
  }
  .fr-box.fr-basic .fr-element{
    flex: 1;
    overflow: visible;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled(ButtonComponent)`
  &&&{
    margin: 0 28px;
  }
`;
